/**
 * 场景会话 hook — 管理 RendererController 生命周期、场景加载、事件桥接。
 *
 * 将 ExplorePage 中的超大 effect 收敛为独立 hook，内部通过子 hook 编排：
 * - useSceneRetry: retry 信号与重试限流
 * - useSceneLoader: controller init / dispose / resize / 场景全流程加载
 * - useSceneAuthRevocation: 私有场景登出撤权 / 登录后重试
 */
import { useSceneRetry } from './useSceneRetry';
import { useSceneLoader } from './useSceneLoader';
import { useSceneAuthRevocation } from './useSceneAuthRevocation';
import type { SceneSessionParams } from './types';

export function useSceneSession(params: SceneSessionParams) {
  const retry = useSceneRetry();

  const cleanupSessionRef = useSceneLoader({
    ...params,
    retryVersion: retry.retryVersion,
    resetRetryCount: retry.resetRetryCount,
  });

  useSceneAuthRevocation({ cleanupSessionRef, retry });

  return { handleRetry: retry.handleRetry };
}
